import MixpanelTracker from 'Mixpanel/mixpanelTracker';
import { CONDITIONAL_CERTIFICATE_TOGGLE_CLICKED, CUSTOMIZE_CERTIFICATE_CLICKED, SIGNATURE_UPLOADED, CUSTOMIZE_CERTIFICATE_TOGGLE_CLICKED, CONDITIONAL_CERTIFICATE_DETAILS } from '../../../mixpanelConstants';
import { DRAWN_SIGNATURE } from './certificateConstants';

const mixpanelTracker = new MixpanelTracker();

export function trackSignatureUploaded(type = DRAWN_SIGNATURE, webinarKey) {
  const properties = {
    Type: type,
    webinarKey
  };
  mixpanelTracker.setEventName(SIGNATURE_UPLOADED);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackCustomiseCertificateClicked(webinarKey) {
  const properties = {
    webinarKey
  };
  mixpanelTracker.setEventName(CUSTOMIZE_CERTIFICATE_CLICKED);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackCertificateToggleClicked(isToggleOn, webinarKey, isConditional) {
  const properties = {
    isToggleOn,
    webinarKey
  };
  mixpanelTracker.setEventName(isConditional ? CONDITIONAL_CERTIFICATE_TOGGLE_CLICKED : CUSTOMIZE_CERTIFICATE_TOGGLE_CLICKED);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackConditionalCertificateDetails(attendanceThreshold, isToggleOn, webinarKey) {
  const properties = {
    attendanceThreshold,
    isToggleOn,
    webinarKey
  };
  mixpanelTracker.setEventName(CONDITIONAL_CERTIFICATE_DETAILS);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

